
const tenantDomain = "thefirstspace.online";
const userFlow = "B2X_1_AMH-ExtUserSignUp";

//authority: "https://login.microsoftonline.com/artmanagementhub.com",

const authorityHost = "login.microsoftonline.com";

export const msalConfig = {
    auth: {
        clientId: "e697c7e7-1cb7-4b87-bdd0-e4ddfe21b9c0",
        authority: `https://${authorityHost}/${tenantDomain}/${userFlow}`,
        redirectUri: "https://artmanagementhub.com",
        postLogoutRedirectUri: "https://artmanagementhub.com",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const apiScope = "api://4d483242-2d75-409e-8195-a14b1c0edfcd/access_as_user"

export const loginRequest = {
    scopes: ["openid", "profile", "email", "offline_access", "api://4d483242-2d75-409e-8195-a14b1c0edfcd/access_as_user"],
    extraQueryParameters: { max_age: "3600" }
};

export const apiTokenRequest = {
    scopes: ["api://4d483242-2d75-409e-8195-a14b1c0edfcd/access_as_user"]
};